const interventions = [
  {
    title: "Réglage oscillo-battant",
    description: "Votre fenêtre oscillo-battant déraille ou ne bascule plus correctement à Erstein ? Nous réglons le mécanisme et remplaçons la pièce si nécessaire.",
    href: "/reglage-fenetre-oscillo-battant",
    icon: "ri-arrow-up-down-line",
  },
  {
    title: "Crémone",
    description: "La crémone de votre fenêtre est bloquée ou la clé ne tourne plus à Erstein ? Nous réparons ou changeons la serrure multipoint sur place.",
    href: "/cremone-fenetre",
    icon: "ri-lock-line",
  },
  {
    title: "Poignée",
    description: "Poignée cassée, molle ou qui tourne dans le vide à Erstein ? Nous remplaçons la poignée et le carré d'entraînement en une seule visite.",
    href: "/poignee-fenetre-bloquee",
    icon: "ri-hand-coin-line",
  },
  {
    title: "Gond & paumelle",
    description: "Votre fenêtre s'affaisse ou frotte contre le cadre à Erstein ? Nous réglons ou remplaçons les gonds et paumelles pour une fermeture parfaite.",
    href: "/gond-paumelle-fenetre",
    icon: "ri-door-open-line",
  },
  {
    title: "Fenêtre qui ferme mal",
    description: "Fermeture difficile, joint défectueux ou infiltrations d'air à Erstein ? Nous diagnostiquons et réparons l'étanchéité de votre fenêtre.",
    href: "/fenetre-ferme-mal",
    icon: "ri-home-smile-line",
  },
];

export default function InterventionsGrid() {
  return (
    <section className="bg-[#EEF2F4] py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#1E3A47] mb-3">
            Nos interventions à Erstein
          </h2>
          <p className="text-[#243038] text-sm md:text-base max-w-2xl mx-auto leading-relaxed">
            Nos techniciens réparent le mécanisme ou la pièce chez vous, dans plus de 90 % des cas. Déplacement et devis gratuits, pièce comprise.
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {interventions.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="group bg-white rounded-2xl border border-[#D7E0E4] p-6 md:p-8 hover:border-[#FF6B4A]/40 transition-colors"
            >
              <div className="w-12 h-12 rounded-xl bg-[#1E3A47]/10 flex items-center justify-center mb-4 group-hover:bg-[#FF6B4A]/10 transition-colors">
                <i className={`${item.icon} text-[#1E3A47] text-xl w-8 h-8 flex items-center justify-center`} />
              </div>
              <h3 className="text-lg font-semibold text-[#1E3A47] mb-2">
                {item.title}
              </h3>
              <p className="text-sm text-[#243038] leading-relaxed mb-4">
                {item.description}
              </p>
              <span className="inline-flex items-center gap-1 text-[#FF6B4A] text-sm font-medium">
                En savoir plus
                <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform" />
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}